export default function getPathLabel(path: string): string {
  const labels = path.split('.');

  return labels[labels.length - 1].replace(/_/g, ' ');
}
